<template>
    <!-- <div class="search-block w-[90%] mx-auto">
        <div class="flex justify-between mt-2">
            <InputComponent :value="searchQuery" @update:modelValue="e => searchQuery = e" placeholder="Пошук..." class="w-[250px]"/>

            <div class="filter w-[228px]">
                <ButtonComponent v-if="currentAdminRole != 'supervisor'" :fullWidth="true" @click="$emit('addGroup')">Додати</ButtonComponent>
            </div>
        </div>
    </div> -->

    <div class="search-header">
        <div class="search-header__row">
            <SearchInput :modelValue="searchQuery" @update:modelValue="e => searchQuery = e" />
            <ButtonComponent @click="$emit('addGroup')" v-if="currentAdminRole != 'supervisor'">Додати</ButtonComponent>
        </div>
    </div>
</template>

<script>
import InputComponent from '@/components/uikit/Input/InputComponent.vue';
import { ref, watch } from 'vue'

    export default {
        name: 'menu-bar',

        setup(props, { emit }) {
            const searchQuery = ref('')

            const currentAdminRole = ref(localStorage.getItem('userType'))

            watch(searchQuery, (newValue) => {
                emit('search', newValue)
            })

            return {
                searchQuery,
                currentAdminRole
            }
        }
    }
</script>

<style scoped lang="scss">
    

</style>
